declare global {
  interface Window {
    dataLayer?: Array<Record<string, any>>;
  }
}
function hasDataLayer(): boolean {
  return typeof window !== 'undefined' && Array.isArray(window.dataLayer);
}

export function pushToDataLayer(data: Record<string, any>) {
  if (!hasDataLayer()) {
    return;
  }

  window.dataLayer?.push({
    ...data,
  });
}
